// Select the header element
  let siteHeader = document.querySelector('.site-header');
  // Get the height of the header
  let siteHeaderHeight = siteHeader.offsetHeight;
  // Add a scroll event listener to the window
  window.addEventListener('scroll', function() {
    // Get the current scroll position
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // If the scroll position is greater than the header height, add the class
    if (scrollTop > siteHeaderHeight) {
      siteHeader.classList.add('header-scrolled');
    } else {
      // Otherwise, remove the class
      siteHeader.classList.remove('header-scrolled');
    }
  });